import SceneProperties from "../data/SceneProperties";
import ActionType from "../models/ActionTypeModel";
import PlatformModel from "../models/PlatformModel";
import PlatformType from '../models/PlatformTypeModel';
import PlayAudio from "../util/PlayAudio";
import GetOrbRouteByIndex from "../data/OrbRoutes";
import PocketTypes from "../models/PocketTypes";

/**
 * CONSTANTS
 */
const FRAME_COUNT = 12;
const DELTA_TIME = 0.1;
const DRAG_FACTOR = 0.97;

/**
 * DURATIONS
 */
const PLATFORM_DURATION = 2000;
const CRUSHER_DURATION = 3000;
const BULLET_DURATION = 5000;
const BATTON_DURATION = 2000;

/**
 * BATTON PROPERTIES
 */
const BATTON_AMPLITUDE = 130;
const BATTON_INITIAL = 45;

class Engine {
    setPorkRoll: any;
    setPlatforms: any;
    setRef: any;
    setPocket: any;
    navigate: any;

    start: number = 0;
    reset: boolean = false;
    special: boolean = false;
    onPortalIndex: number = -1;
    moveRight: boolean = false;
    moveLeft: boolean = false;
    jump: boolean = false;
    left: number;
    bottom: number;
    rotate: number = 0;
    velocityX: number = 0;
    velocityY: number = 0;
    bleedBottom: number = -1;
    newPorkRoll: any = {};
    paintRef: any;
    direction: number = 1;
    music: boolean = false;
    died: boolean = false;
    onOrb: boolean = false;
    dieCount: number = 0;

    constructor(setRef: any, setPorkRoll: (p: PorkrollModel) => void, setPlatforms: (p: PlatformModel[]) => void, navigate: (p: number) => void, setPocket: (pock: string) => void) {
        this.setPorkRoll = setPorkRoll;
        this.setPlatforms = setPlatforms;
        this.setRef = setRef;
        this.navigate = navigate;
        this.setPocket = setPocket;

        // console.log("Game Started")
        if (SceneProperties.checkPoint == null) {
            this.left = 0;
            this.bottom = 0;
        } else {
            this.left = SceneProperties.checkPoint.left;
            this.bottom = SceneProperties.checkPoint.bottom;
        }

        this.setRef(window.requestAnimationFrame(this.paint));
    }

    initEngine = () => {
        this.start = 0;
        this.direction = 1;
        this.died = false;
        this.onOrb = false;

        //reset
        this.reset = false;

        //special
        this.special = false;

        //transitions
        this.onPortalIndex = -1;

        //actions
        this.moveRight = false;
        this.moveLeft = false;
        this.jump = false;

        //changing properties
        this.left = 0;
        this.bottom = 0;

        this.rotate = 0;
        this.velocityX = 0;
        this.velocityY = 0;

        //tracking edge data
        this.bleedBottom = -1;
        this.newPorkRoll = {};
    }

    //collision functions
    isBleeding = () => {
        for (var index = 0; index < SceneProperties.platforms.length; index++) {
            let platform = SceneProperties.platforms[index];

            if (this.bottom <= (platform.bottom + platform.height) && this.bottom > (platform.bottom - SceneProperties.playerSize)) {
                if (this.left < (platform.width + platform.left) && this.left > (platform.width + platform.left - SceneProperties.getPlayerRadius())) {
                    let bleedPerp = SceneProperties.getPlayerRadius() - (platform.width + platform.left - this.left);
                    let bleed = SceneProperties.getPlayerRadius() - Math.sqrt(Math.pow(SceneProperties.getPlayerRadius(), 2) - Math.pow(bleedPerp, 2));
                    let bleedHeight = platform.bottom + platform.height - bleed;

                    if (this.bleedBottom === -1) {
                        //starting to bleed
                        this.bleedBottom = bleedHeight;
                    } else {
                        let bleedVel = -1 * SceneProperties.getFallGravity() * DELTA_TIME;
                        this.bleedBottom += (bleedVel * DELTA_TIME)
                    }

                    if (this.bleedBottom > bleedHeight) {
                        bleedHeight = this.bleedBottom;
                    }

                    if ((SceneProperties.getPlayerRadius() - bleed) <= SceneProperties.bleadTweak) {
                        this.bottom = bleedHeight;
                    }

                    return bleedHeight;
                }

                if (this.left < (platform.left - SceneProperties.getPlayerRadius()) && this.left > (platform.left - SceneProperties.playerSize)) {
                    let bleedPerp = platform.left - (this.left + SceneProperties.getPlayerRadius());
                    let bleed = SceneProperties.getPlayerRadius() - Math.sqrt(Math.pow(SceneProperties.getPlayerRadius(), 2) - Math.pow(bleedPerp, 2));
                    let bleedHeight = platform.bottom + platform.height - bleed;

                    if (this.bleedBottom === -1) {
                        //starting to bleed
                        this.bleedBottom = bleedHeight;
                    } else {
                        let bleedVel = -1 * SceneProperties.getFallGravity() * DELTA_TIME;
                        this.bleedBottom += (bleedVel * DELTA_TIME)
                    }

                    if (this.bleedBottom > bleedHeight) {
                        bleedHeight = this.bleedBottom;
                    }

                    if ((SceneProperties.getPlayerRadius() - bleed) <= SceneProperties.bleadTweak) {
                        this.bottom = bleedHeight;
                    }

                    return bleedHeight;
                }
            }
        }

        this.bleedBottom = -1;
        return null;
    }

    inPlatform = () => {
        for (var index = 0; index < SceneProperties.platforms.length; index++) {
            let platform = SceneProperties.platforms[index];

            if (this.left < (platform.width + platform.left) && this.left > (platform.left - SceneProperties.playerSize)) {
                if (this.bottom < (platform.bottom + platform.height) && this.bottom > (platform.bottom - SceneProperties.playerSize)) {
                    return index;
                }
            }
        }

        return null;
    }

    //update horizontal
    updateHorizontal = () => {
        this.left += (this.velocityX * DELTA_TIME);
        this.rotate += (this.velocityX * DELTA_TIME);

        //ensure within bounds
        if (this.left < 0) {
            this.left = 0;
        } else if (this.left > ((document.body.clientWidth * SceneProperties.totalWidthFact) - SceneProperties.playerSize)) {
            this.left = (document.body.clientWidth * SceneProperties.totalWidthFact) - SceneProperties.playerSize;
        }

        //collision
        let index = this.inPlatform();

        if (index != null) {
            let halfPoint = (SceneProperties.platforms[index].width / 2) + SceneProperties.platforms[index].left;

            if (this.left <= halfPoint) {
                //collide right
                this.velocityX = 0;
                this.left = (SceneProperties.platforms[index].left - SceneProperties.playerSize);
            } else {
                //collide left
                this.velocityX = 0;
                this.left = (SceneProperties.platforms[index].width + SceneProperties.platforms[index].left);
            }
        }

        this.newPorkRoll.left = this.left;
        this.newPorkRoll.rotate = this.rotate;
    }

    //paint horizontal
    paintHorizontal = () => {
        if (this.moveRight || this.moveLeft) {
            if ((this.moveLeft && this.velocityX > 0) || (this.moveRight && this.velocityX < 0)) {
                //working against motion
                this.velocityX = 0;
            } else {
                //working with motion
                let deltaV = (SceneProperties.acceleration * DELTA_TIME);
                if (this.moveLeft) {
                    deltaV *= -1;
                }

                this.velocityX += deltaV;
            }

            //modify if size higher than top speed
            if (Math.abs(this.velocityX) > SceneProperties.topSpeed) {
                if (this.velocityX < 0) {
                    //going left
                    this.velocityX = -1 * SceneProperties.topSpeed;
                } else {
                    this.velocityX = SceneProperties.topSpeed;
                }
            }

            this.updateHorizontal();
        }

        //dampen
        if ((!this.moveRight && this.velocityX > 0) || (!this.moveLeft && this.velocityX < 0)) {
            this.velocityX *= DRAG_FACTOR;
            if (Math.abs(this.velocityX) < SceneProperties.dragLimit) this.velocityX = 0;

            this.updateHorizontal();
        }
    }

    //updates vertical
    updateVertical = () => {
        this.bottom += (this.velocityY * DELTA_TIME);

        //ensure within bounds
        if (this.bottom < 0) {
            this.bottom = 0;
        }

        //collision
        let index = this.inPlatform();

        if (index != null) {
            if (this.velocityY > 0) {
                //bump
                this.velocityY = 0;
                this.bottom = (SceneProperties.platforms[index].bottom - SceneProperties.playerSize);
            } else {
                //land
                this.bottom = (SceneProperties.platforms[index].bottom + SceneProperties.platforms[index].height);
                this.velocityY = 0;
            }
        }

        this.newPorkRoll.bottom = this.bottom;
    }

    //checks if grounded
    isGrounded = () => {
        if (this.velocityY > 0) {
            return false;
        }

        if (this.bottom <= 0) {
            return true;
        }

        let onGround = false;

        for (let i = 0; i < SceneProperties.platforms.length; i++) {
            let platform = SceneProperties.platforms[i];
            if (this.left < (platform.width + platform.left) && this.left > (platform.left - SceneProperties.playerSize)) {
                if (this.bottom === (platform.bottom + platform.height)) {
                    onGround = true;
                }
            }
        }

        //collisions
        if (this.inPlatform() != null || onGround) {
            return true;
        }

        return false;
    }

    //paint vertical
    paintVertical = () => {
        if (this.isGrounded()) {
            if (this.jump) {
                //apply velocity up
                this.velocityY = SceneProperties.jumpPower;
                this.updateVertical();

                PlayAudio("sound_jump", 0.1);

            }
        } else {
            if (this.velocityY > 0) {
                //going up
                if (this.jump) {
                    //apply light acceleration
                    this.velocityY -= (SceneProperties.gravity * DELTA_TIME)

                } else {
                    //apply heavy acceleration
                    this.velocityY -= (SceneProperties.getHeavyGravity() * DELTA_TIME)
                }
            } else {
                //going down
                //apply fall acceleration
                this.velocityY -= (SceneProperties.getFallGravity() * DELTA_TIME)
            }
            this.updateVertical();
        }
    }

    //paint bleeds
    paintBleeds = () => {
        let bleed = this.isBleeding();

        if (bleed != null) {
            this.newPorkRoll.bottom = bleed;
        }
    }

    //paint move platforms
    paintMovePlatforms = () => {
        for (var index = 0; index < SceneProperties.platforms.length; index++) {
            let platform = SceneProperties.platforms[index];


            if (platform.type === PlatformType.MOVING) {
                let stretchFact = 1;

                let totalDurMillis = PLATFORM_DURATION * SceneProperties.getSpeedFactor();

                if (SceneProperties.getSpeedFactor() > 1.2){
                    stretchFact = 1.5;
                    totalDurMillis *= 1.5;
                }
                let halfDurMillis = totalDurMillis / 2;

                let now = new Date();
                let timeCursorMillisNormalised = (now.getTime() % totalDurMillis) - halfDurMillis;
                let shift = (Math.abs(timeCursorMillisNormalised) / halfDurMillis) * platform.action.amplitude * stretchFact;

                switch (platform.action.type) {
                    case ActionType.LEFT:
                        let newWidth = platform.action.init - shift;
                        platform.width = platform.action.init - newWidth;
                        break;
                    case ActionType.RIGHT:
                        let newLeft = platform.action.init + shift - platform.width - ((stretchFact - 1) * platform.action.amplitude);
                        platform.left = newLeft;
                        break;
                    default:
                        console.log("unsupported action type in engine")
                        break;
                }
            }
        }

        this.setPlatforms(SceneProperties.platforms);
    }

    //paint crushers
    paintCrushers = () => {
        for (var index = 0; index < SceneProperties.crushers.length; index++) {
            let crusher = SceneProperties.crushers[index];

            let totalDurMillis = CRUSHER_DURATION * SceneProperties.getSpeedFactor();
            let halfDurMillis = totalDurMillis / 2;

            let now = new Date();
            let timeCursorMillisNormalised = (now.getTime() % totalDurMillis) - halfDurMillis;
            
            let ampFact = 1;
            if (SceneProperties.getSpeedFactor() > 1.2) ampFact = 0.7;

            let shift = (Math.abs(timeCursorMillisNormalised) / halfDurMillis) * crusher.amplitude * ampFact;

            let newHeight = (crusher.init) - shift;
            let newBottom = shift;

            if (crusher.offset === 1) {
                let temp = newHeight;
                newHeight = newBottom + (0.02 * window.innerHeight);
                newBottom = temp - (0.02 * window.innerHeight);
            } else {
                newHeight -= (1- ampFact) * crusher.amplitude;
                newBottom += (1- ampFact) * crusher.amplitude;
            }

            crusher.height = newHeight;
            crusher.bottom = newBottom;
        }
    }

    checkDead = () => {

        //hit spikes
        for (var index = 0; index < SceneProperties.spikes.length; index++) {
            let spike = SceneProperties.spikes[index];

            //within horizontal bounds
            if (this.left + SceneProperties.playerSize > spike.left && this.left < spike.left + spike.size) {
                if (spike.isTop) {
                    //check top collision
                    if (this.bottom + SceneProperties.playerSize > spike.bottom + (spike.size / 2) && this.bottom < spike.bottom + spike.size) {
                        this.died = true;
                        return;
                    }
                } else {
                    //check bottom collision
                    if (this.bottom + SceneProperties.playerSize > spike.bottom && this.bottom < spike.bottom + (spike.size / 2)) {
                        this.died = true;
                        return;
                    }
                }
            }
        }

        //hit crusher
        for (index = 0; index < SceneProperties.crushers.length; index++) {
            let crusher = SceneProperties.crushers[index];

            //main column
            if (this.left + SceneProperties.playerSize > crusher.left && this.left < crusher.left + crusher.width) {
                if (this.bottom + SceneProperties.playerSize > crusher.bottom && this.bottom < crusher.bottom + crusher.height) {
                    this.died = true;
                    return;
                }
            }

            //foot MUST MATCH CSS. assuming central
            const widthFactor = 2;
            const heightFactor = 0.12

            const widthOffset = (((crusher.width * widthFactor) - crusher.width) / 2);
            const heightOffset = heightFactor * crusher.height;
            if (this.left + SceneProperties.playerSize > crusher.left - widthOffset && this.left < crusher.left + crusher.width + widthOffset) {
                if (this.bottom + SceneProperties.playerSize > crusher.bottom && this.bottom < crusher.bottom + heightOffset) {
                    this.died = true;
                    return;
                }
            }
        }

        //hit batton
        if (this.checkDeadBatton()) {
            this.died = true;
            return;
        }

        //hit bullets
        for (index = 0; index < SceneProperties.bullets.length; index++) {
            let bullet = SceneProperties.bullets[index];

            //main column
            if (this.left + SceneProperties.playerSize > bullet.left && this.left < bullet.left + bullet.width) {
                if (this.bottom + SceneProperties.playerSize > bullet.bottom && this.bottom < bullet.bottom + bullet.height) {
                    this.died = true;
                    return;
                }
            }
        }

    }

    checkDeadBatton = () => {
        //track player
        let ax = this.left + SceneProperties.getPlayerRadius();
        let ay = this.bottom + SceneProperties.getPlayerRadius();
        // SceneProperties.battonTrackers[0].left = ax;
        // SceneProperties.battonTrackers[0].bottom = ay;

        //assign trackers
        let batton = SceneProperties.battons[0];
        let theta = this.deg2rad(90 - batton.rotate);

        //define deadzone
        let dzleft = batton.left - (batton.width / 2);
        let dzbottom = batton.bottom;
        let dzheight = batton.height;
        let dzwidth = batton.width;

        //set batton bottom left tracker
        // SceneProperties.battonTrackers[1].left = dzleft;
        // SceneProperties.battonTrackers[1].bottom = dzbottom;

        //set batton pivot
        let px = batton.left
        let py = batton.bottom - batton.height
        // SceneProperties.battonTrackers[2].left = px;
        // SceneProperties.battonTrackers[2].bottom = py;

        //set player relative tracker
        let dx = px - ax;
        let dy = ay - py;
        let magD = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));

        //get alpha
        let alpha = Math.PI - (theta + Math.atan(dy / dx));

        let ddx = Math.sin(alpha) * magD;
        let ddy = Math.cos(alpha) * magD;

        let bx = px + ddx;
        let by = py - ddy;

        if (ax < px) {
            //to the left of pivot
            bx = px - ddx;
            by = py + ddy;
        }

        //scrape borders
        if (bx + SceneProperties.getPlayerRadius() < dzleft
            || bx - SceneProperties.getPlayerRadius() > dzleft + dzwidth
            || by + SceneProperties.getPlayerRadius() < dzbottom
            || by - SceneProperties.getPlayerRadius() > dzbottom + dzheight
        ) {
            return false;
        }

        // SceneProperties.battonTrackers[3].left = bx;
        // SceneProperties.battonTrackers[3].bottom = by;

        //in midsection
        if (bx > dzleft && bx < dzleft + dzwidth) {
            return true;
        }

        //in side flaps
        if (by > dzbottom && by < dzbottom + dzheight) {
            return true;
        }

        let deltaR;

        //in corners
        if (bx <= dzleft) {
            //left corners
            if (by <= dzbottom) {
                //bottom-left
                deltaR = Math.sqrt(Math.pow(dzleft - bx, 2) + Math.pow(dzbottom - by, 2));
            } else {
                //top-left
                deltaR = Math.sqrt(Math.pow(dzleft - bx, 2) + Math.pow(by - (dzbottom + dzheight), 2));
            }
        } else {
            //right corners
            if (by <= dzbottom) {
                //bottom-right
                deltaR = Math.sqrt(Math.pow(bx - (dzleft + dzwidth), 2) + Math.pow(dzbottom - by, 2));
            } else {
                //top-right
                deltaR = Math.sqrt(Math.pow(bx - (dzleft + dzwidth), 2) + Math.pow(by - (dzbottom + dzheight), 2));
            }
        }

        if (deltaR < SceneProperties.getPlayerRadius()) {
            return true;
        }

        return false;
    }

    checkGlows = () => {
        var noPocket = true;
        for (var index = 0; index < SceneProperties.portals.length; index++) {
            let portal = SceneProperties.portals[index];

            //main column
            if (this.left + SceneProperties.playerSize > portal.left && this.left < portal.left + portal.width) {
                if (this.bottom + SceneProperties.playerSize > portal.bottom && this.bottom < portal.bottom + portal.height) {
                    SceneProperties.playerGlow = "green";
                    this.onPortalIndex = index;
                    this.setPocket(PocketTypes.TELEPORT);
                    noPocket = false;
                    return;
                }
            }

            SceneProperties.playerGlow = null;
            this.onPortalIndex = -1;
        }

        let inOrb = false;
        for (index = 0; index < SceneProperties.orbs.length; index++) {
            let orb = SceneProperties.orbs[index];

            //main column
            if (this.left + SceneProperties.playerSize > orb.left && this.left < orb.left + orb.size) {
                if (this.bottom + SceneProperties.playerSize > orb.bottom && this.bottom < orb.bottom + orb.size) {
                    SceneProperties.playerGlow = "yellow";
                    inOrb = true;
                    if (!this.onOrb) {
                        PlayAudio("sound_orb", 0.5);
                        this.onOrb = true;
                    }

                    //track checkpoint
                    SceneProperties.checkPoint = {
                        left: this.left,
                        bottom: this.bottom
                    }

                    //navigate away
                    if (this.special) {
                        this.navigate(index);
                    }

                    //change pocket
                    let orbRoute = GetOrbRouteByIndex(index);

                    if (orbRoute !== null) {
                        if (orbRoute.pocket === PocketTypes.FAITH){
                            this.dieCount = 0;
                        }

                        this.setPocket(orbRoute.pocket);
                    } else {
                        console.log("Err: no matches OrbRoutes or duplicate matches");
                    }

                    return;
                }
            }
            SceneProperties.playerGlow = null;
        }

        if (!inOrb && noPocket) {
            this.onOrb = false;
            this.setPocket("");
        }
    }

    performTransition = () => {
        if (this.special) {
            if (this.onPortalIndex !== -1) {
                let portInd = 0;

                if (this.onPortalIndex === 0) {
                    portInd = 1;
                }

                this.bottom = SceneProperties.portals[portInd].bottom;
                this.left = SceneProperties.portals[portInd].left;
                this.velocityX = 1; //workaround for stationary bug

                PlayAudio("sound_portal", 0.1)
            }
            this.special = false;
        }
    }

    deg2rad = (deg: number): number => {
        return deg * Math.PI / 180;
    }

    rotateBatton = () => {
        let totalDurMillis = BATTON_DURATION * SceneProperties.getSpeedFactor();

        let angFact = 1;
        if (SceneProperties.getSpeedFactor() > 1.2){
            angFact = 0.65;
            totalDurMillis *= 1.3;
        }

        let halfDurMillis = totalDurMillis / 2;

        let now = new Date();
        let timeCursorMillisNormalised = (now.getTime() % totalDurMillis) - halfDurMillis;
        let shift = (BATTON_AMPLITUDE - ((Math.abs(timeCursorMillisNormalised) / halfDurMillis) * BATTON_AMPLITUDE * angFact));

        SceneProperties.battons[0].rotate = BATTON_INITIAL - shift;
    }

    paintBullets = () => {
        //shift left
        for (var index = 0; index < SceneProperties.bullets.length; index++) {
            let bullet = SceneProperties.bullets[index];

            let totalDurMillis = BULLET_DURATION * SceneProperties.getSpeedFactor();
            if (SceneProperties.getSpeedFactor() < 1.2){
                totalDurMillis *= 0.7;
            }
            
            let now = new Date();
            let timeCursorMillisNormalised = now.getTime() % totalDurMillis;
            let shift = (Math.abs(timeCursorMillisNormalised) / totalDurMillis) * SceneProperties.bulletAmplitude;

            shift = (shift + ((index * SceneProperties.bulletAmplitude) / SceneProperties.bullets.length)) % SceneProperties.bulletAmplitude;

            bullet.left = shift - SceneProperties.bulletWidth - 0.5 * SceneProperties.bulletAmplitude;
        }
    }

    oscillateOrbs = () => {
        //oscillate
        for (var index = 0; index < SceneProperties.orbs.length; index++) {
            let orb = SceneProperties.orbs[index];

            let now = new Date();
            orb.bottom = orb.init + SceneProperties.orbAmplitude * Math.cos(now.getTime() / 400)
        }
    }

    //paint
    paint = (timestamp: number) => {
        let elapsed = timestamp - this.start;


        if (elapsed >= FRAME_COUNT) {    //only render every 1 out of FRAME_COUNT frames
            this.start = timestamp;
            this.newPorkRoll = {};

            this.checkGlows();
            this.performTransition();
            this.rotateBatton();

            this.paintMovePlatforms();
            this.paintVertical();
            this.paintHorizontal();
            this.paintBleeds();
            this.paintCrushers();
            this.paintBullets();
            this.checkDead();
            this.oscillateOrbs();

            this.newPorkRoll.direction = this.direction;
            this.setPorkRoll(this.newPorkRoll);
        }

        //stop music if mute
        if (SceneProperties.isMute) {
            const bg = document.getElementById("sound_bg") as HTMLAudioElement;
            if (bg != null) {
                bg.pause();
                this.music = false;
            }
        } else {
            PlayAudio("sound_bg");
        }

        //paint next frame
        if (this.reset === false && this.died === false) {
            this.setRef(window.requestAnimationFrame(this.paint));
        } else {
            //reset to init state

            if (this.died) {
                PlayAudio("sound_die", 0.15);
                this.dieCount++;
                if (this.dieCount >= 5){
                    alert("Too hard?\nTweak the difficulty in the settings menu!");
                    this.dieCount = 0;
                }
            } else {
                //stop backgroun
                const bg = document.getElementById("sound_bg") as HTMLAudioElement;
                if (bg != null) {
                    bg.pause();
                    this.music = false;
                }
            }

            this.initEngine();
            let yeet = {
                left: this.left,
                bottom: this.bottom,
                rotate: this.rotate,
                direction: 1
            }
            this.setPorkRoll(yeet);

            // console.log("Game restarted")
            this.setRef(window.requestAnimationFrame(this.paint));
        }
    }

    addMusic = () => {
        if (this.music) return;

        PlayAudio("sound_bg");
        this.music = true;
    }


    MoveRight = () => { this.moveRight = true; this.direction = 1; this.addMusic(); }
    MoveLeft = () => { this.moveLeft = true; this.direction = -1; this.addMusic(); }
    Jump = () => { this.jump = true; this.addMusic() }
    ResetRight = () => { this.moveRight = false; this.addMusic() }
    ResetLeft = () => { this.moveLeft = false; this.addMusic() }
    ResetJump = () => { this.jump = false; this.addMusic() }
    ResetGame = () => { this.reset = true; this.addMusic() }
    DoSpecial = () => { this.special = true; this.addMusic() }
}



export default Engine
